import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            reportingConfiguration: 'ReportsUsers/getReportingConfiguration'
        })
    },
    methods: {
        hideColumns () {
            if (!this.reportingConfiguration.hasDepartments) {
                this.columnHiddenOption.defaultHiddenColumnKeys.push('department')
            }
            if (!this.reportingConfiguration.hasTeams) {
                this.columnHiddenOption.defaultHiddenColumnKeys.push('team')
            }
            if (!this.reportingConfiguration.hasCompanies) {
                this.columnHiddenOption.defaultHiddenColumnKeys.push('company')
            }
        }
    },
    created () {
        this.hideColumns()
    }
}
